import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  projectInfo: {},
  projectTab: {},
  tabWarnings: {},
  refetchTrigger: {},
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectInfo: (state, action) => {
      const { projectId, data } = action.payload;
      state.projectInfo[projectId] = data;
    },
    setProjectTab: (state, action) => {
      const { projectId, tabData } = action.payload;
      state.projectTab[projectId] = tabData;
    },
    setTabWarnings: (state, action) => {
      const { projectId, data } = action.payload;
      state.tabWarnings[projectId] = data;
    },
    clearProjectInfo: (state, action) => {
      const projectId = action.payload;
      delete state.projectInfo[projectId];
    },
    clearProjectTab: (state, action) => {
      const projectId = action.payload;
      delete state.projectTab[projectId];
    },
    clearTabWarnings: (state, action) => {
      const projectId = action.payload;
      delete state.tabWarnings[projectId];
    },
    triggerProjectRefetch: (state, action) => {
      const projectId = action.payload;
      state.refetchTrigger[projectId] = Date.now();
    },
  },
});

export const {
  setProjectInfo,
  setProjectTab,
  setTabWarnings,
  clearProjectInfo,
  clearProjectTab,
  clearTabWarnings,
  triggerProjectRefetch
} = projectSlice.actions;

export default projectSlice.reducer;
